<p-dialog [header]="popupHeader" [(visible)]="displayCreateRecordDialog" [style]="{ width: '75vw' }"
    (onHide)="closeCreateRecord()" [closable]="false" [modal]="true" [responsive]="true">

    <form [formGroup]="salesOrderForm" novalidate>
        <div *ngIf="!fromUpdateRecord" class="card">
            <div class="p-grid">
                <div class="p-col-6">
                    <label>Module <span class="required-field">*</span></label>
                    <p-dropdown appendTo="body" [options]="modules" [(ngModel)]="selectedRecordModule"
                        [ngModelOptions]="{standalone: true}" [disabled]="viewOnly||selectedActionCreateRecord||(salesOrderForm.getRawValue().workflowCreateRecordProducts?.length>0)"
                        optionLabel="name" dataKey="id" placeholder="Select Module" (onChange)="selectModule()">
                    </p-dropdown>
                </div>
                <div class="p-col-6">
                    <label>Channel <span class="required-field">*</span></label>
                    <p-dropdown appendTo="body" [options]="channels" formControlName="selectedChannel"
                        [disabled]="viewOnly||selectedActionCreateRecord||(salesOrderForm.getRawValue().workflowCreateRecordProducts?.length>0)" optionLabel="channelName" dataKey="channelId" placeholder="Select Channel"
                        [filter]="true" [resetFilterOnHide]="true">
                    </p-dropdown>

                    <div *ngIf="detailsFormErrors?.selectedChannel" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedChannel }}</small>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="productSelectionFor.includes(selectedRecordModule?.id) && salesOrderForm.getRawValue().selectedChannel">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <div class="card">
                        <div class="p-d-flex p-mb-2">
                            Location:
                            <p-dropdown [options]="allLocations" formControlName="selectedLocation" dataKey="id"
                                optionLabel="name" [disabled]="viewOnly||(salesOrderForm.getRawValue().workflowCreateRecordProducts?.length>0)" appendTo="body" class="small inlineDD"
                                [ngStyle]="{maxwidth: '250px'}" [dropdownIcon]="dropdownIcon" [filter]="true">
                            </p-dropdown>
                        </div>

                        <div *ngIf="detailsFormErrors?.selectedLocation" class="p-invalid">
                            <small>{{ detailsFormErrors?.selectedLocation }}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col" *ngIf="checkedFields?.paymentterm?.isChecked">
                    <div class="card">
                        <h6 class="p-mb-0">
                            {{ checkedFields.paymentterm?.labelName }}
                        </h6>
                        <p class="p-mb-0">
                            <p-dropdown [options]="allPaymentTerms" optionLabel="name" optionValue="id"
                                appendTo="body" dataKey="id" class="small" [filter]="true"
                                formControlName="paymentTermId" [showClear]="true"
                                placeholder="{{ 'Select ' + checkedFields.paymentterm?.labelName }}"
                                [dropdownIcon]="dropdownIcon" [disabled]="viewOnly">
                            </p-dropdown>
                        </p>
                    </div>
                </div>
                <div class="p-col" *ngIf="checkedFields?.paymentmethod?.isChecked">
                    <div class="card">
                        <h6 class="p-mb-0">
                            {{ checkedFields.paymentmethod?.labelName }}
                        </h6>
                        <p class="p-mb-0">
                            <p-dropdown [options]="allPaymentMethods" optionLabel="name" optionValue="id"
                                appendTo="body" dataKey="id" class="small" [filter]="true"
                                formControlName="paymentMethodId" [showClear]="true"
                                placeholder="{{ 'Select ' + checkedFields.paymentmethod?.labelName }}"
                                [dropdownIcon]="dropdownIcon" [disabled]="viewOnly">
                            </p-dropdown>
                        </p>
                    </div>
                </div>
                <div class="p-col" *ngIf="checkedFields.shippingterm?.isChecked">
                    <div class="card">
                        <h6 class="p-mb-0">
                            {{ checkedFields.shippingterm?.labelName }}
                        </h6>
                        <p class="p-mb-0">
                            <p-dropdown [options]="allShippingTerms" optionLabel="name" optionValue="id"
                                appendTo="body" dataKey="id" class="small" [filter]="true"
                                formControlName="shippingTermId" [showClear]="true"
                                placeholder="{{ 'Select ' + checkedFields.shippingterm?.labelName }}"
                                [dropdownIcon]="dropdownIcon" [disabled]="viewOnly">
                            </p-dropdown>
                        </p>
                    </div>
                </div>
                <div class="p-col" *ngIf="checkedFields.shippingmethod?.isChecked">
                    <div class="card">
                        <h6 class="p-mb-0">
                            {{ checkedFields.shippingmethod?.labelName }}
                        </h6>
                        <p class="p-mb-0 p-mt-2">
                            <liono-treeSelect [options]="shippingMethods" appendTo="body"
                                formControlName="shippingMethod" display="comma"
                                placeholder="{{ 'Select ' + checkedFields.shippingmethod?.labelName }}"
                                [metaKeySelection]="false" selectionMode="single" class="small inlineDD custom-margin">
                            </liono-treeSelect>
                        </p>
                    </div>
                </div>
                <div class="p-col" *ngIf="checkedFields.salesrep?.isChecked">
                    <div class="card">
                        <h6 class="p-mb-0">
                            {{ checkedFields.salesrep?.labelName }}
                        </h6>
                        <p class="p-mb-0">
                            <p-dropdown [options]="allUser" optionLabel="name" optionValue="id"
                                appendTo="body" dataKey="id" class="small" [filter]="true"
                                formControlName="salesRepId" [showClear]="true"
                                placeholder="{{ 'Select ' + checkedFields.salesrep?.labelName }}"
                                [dropdownIcon]="dropdownIcon" [disabled]="viewOnly">
                            </p-dropdown>
                        </p>
                    </div>
                </div>
            </div>
            <div *ngIf="!viewOnly" class="header p-field p-formgrid p-grid">
                <div class="p-col-3"></div>
                <div class="p-col-6">
                    <app-barcode-product-search [locationId]="salesOrderForm.getRawValue().selectedLocation?.id" [accountId]="0"
                        (onProductSelect)="onProductSearchComplete($event)">
                    </app-barcode-product-search>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12" formArrayName="workflowCreateRecordProducts">
                    <p-table [value]="getAddedProducts(salesOrderForm)" styleClass="p-datatable-gridlines p-datatable-striped" dataKey="value.productId">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 5rem"></th>
                                <th *ngIf="checkedFields.item?.isChecked">{{ checkedFields.item.labelName }}</th>
                                <th *ngIf="checkedFields.description?.isChecked">{{ checkedFields.description.labelName }}</th>
                                <th *ngIf="checkedFields.qty?.isChecked" style="width: 80px;">{{ checkedFields.qty.labelName }}</th>
                                <th *ngIf="checkedFields.uom?.isChecked">{{ checkedFields.uom.labelName }}</th>
                                <th *ngIf="checkedFields.rate?.isChecked"  style="width: 150px;">{{ checkedFields.rate.labelName }}</th>
                                <th *ngIf="checkedFields.totalamount?.isChecked" style="width: 150px;">{{ checkedFields.totalamount.labelName }}</th>
                                <th *ngIf="discountEnabled && checkedFields.tbldiscount?.isChecked">{{ checkedFields.tbldiscount.labelName }}</th>
                                <th *ngIf="footerTaxEnabled && checkedFields.tbltax?.isChecked" style="width: 80px;">{{ checkedFields.tbltax.labelName }}</th>
                                <th *ngIf="checkedFields.table_handlingfee?.isChecked">{{ checkedFields.table_handlingfee.labelName }}</th>
                                <th *ngIf="checkedFields.amount?.isChecked" style="width: 150px;">{{ checkedFields.amount.labelName }}</th>
                                <th style="width: 4rem" class="p-py-0" *ngIf="!viewOnly">
                                    <span class="btnBars" (click)="openProductsDialog()">
                                        <i class="pi pi-plus"></i>
                                    </span>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-productControl let-index="rowIndex" let-expanded="expanded">
                            <tr [formGroupName]="index">
                                <td style="width: 5rem">
                                    <button type="button" [pRowToggler]="productControl" pButton pRipple class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" *ngIf="productControl.value?.bundleDetails?.length > 0;" style="width: 1.25rem; height: 1.25rem;"></button>
                                </td>
                                <td *ngIf="checkedFields.item?.isChecked">
                                    {{ productControl.value?.itemNo }}
                                </td>
                                <td *ngIf="checkedFields.description?.isChecked">
                                    {{ productControl.value.description.length > 55 ? (productControl.value.description | slice: 0:55) + "..." :
                                    productControl.value.description }}
                                </td>
                                <td *ngIf="checkedFields.qty?.isChecked" pEditableColumn [pEditableColumnRowIndex]="index">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <p-inputNumber formControlName="productQty" [min]="0" mode="decimal" step="0"
                                            [minFractionDigits]="getDecimalPlacesCached(productControl.value?.productUOM, productControl.value?.productUOMId)"
                                                (keypress)="isNumberKey($event)"
                                                [maxFractionDigits]="getDecimalPlacesCached(productControl.value?.productUOM, productControl.value?.productUOMId)"
                                                (focusout)="updateBundleQuantity(productControl)"
                                                [disabled]="viewOnly"></p-inputNumber>
                                        </ng-template>
                                        <ng-template pTemplate="output">{{ productControl.value?.productQty  | customNumberFormat: getDecimalPlacesCached(productControl.value.productUOM, productControl.value?.productUOMId) }} </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="checkedFields.uom?.isChecked" pEditableColumn class="action">
                                    <p-dropdown
                                        [options]="productControl.value.productUOM"
                                        formControlName="productUOMId"
                                        optionLabel="uomName"
                                        optionValue="unitOfMeasureId" appendTo="body"
                                        class="noBorderDD" [dropdownIcon]="dropdownIcon"
                                        [disabled]="viewOnly">
                                    </p-dropdown>
                                </td>
                                <td *ngIf="checkedFields.rate?.isChecked" pEditableColumn class="action">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input" *ngIf="productControl.value.typeId != typeIds.BundleTypeId">
                                            <p-inputNumber formControlName="productPrice" mode="decimal" [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2" (keypress)="isNumberKey($event)" [disabled]="viewOnly"></p-inputNumber>
                                        </ng-template>
                                        <ng-template pTemplate="output" *ngIf="productControl.value.typeId != typeIds.BundleTypeId"> {{ productControl.value.productPrice | customNumberFormat: fractionDigits | currencySymbol}} </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="checkedFields.totalamount?.isChecked">
                                    {{ productControl.value?.amount | customNumberFormat: fractionDigits | currencySymbol }}
                                </td>
                                <td class="action" *ngIf="discountEnabled && checkedFields.tbldiscount?.isChecked">
                                    <div class="p-d-flex" *ngIf="productControl.value.typeId != typeIds.BundleTypeId">
                                        <p-dropdown
                                            formControlName="discountId"
                                            class="small"
                                            [options]="discountOptions"
                                            optionLabel="additionalDescription"
                                            optionValue="id"
                                            appendTo="body"
                                            [dropdownIcon]="dropdownIcon"
                                            [showClear]="true" placeholder="Select"
                                            (onChange)="changeRowDiscount($event,productControl)"
                                            [disabled]="viewOnly">
                                        </p-dropdown>
                                        <p-inputNumber formControlName="discountAmount" class="noBorder fix-width" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [min]="0" [readonly]="viewOnly || !productControl.value.discountId"></p-inputNumber>
                                    </div>
                                </td>
                                <td *ngIf="checkedFields.tbltax?.isChecked">
                                    {{ (0.0) | customNumberFormat: fractionDigits | currencySymbol }}
                                </td>
                                <td class="action" *ngIf="checkedFields.table_handlingfee?.isChecked">
                                    <div class="p-d-flex" *ngIf="productControl.value.typeId != typeIds.BundleTypeId">
                                        <p-dropdown
                                            formControlName="handlingChargeId"
                                            class="small"
                                            [options]="additionalFees"
                                            optionLabel="additionalname"
                                            optionValue="id"
                                            appendTo="body"
                                            [dropdownIcon]="dropdownIcon"
                                            [showClear]="true" placeholder="Select"
                                            (onChange)="changeRowHandlingFee($event,productControl)"
                                            [disabled]="viewOnly">
                                        </p-dropdown>
                                        <p-inputNumber formControlName="handlingChargeAmount" class="noBorder fix-width" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [min]="0" [readonly]="viewOnly || !productControl.value.handlingChargeId"></p-inputNumber>
                                    </div>
                                </td>
                                <td *ngIf="checkedFields.amount?.isChecked">
                                    {{ productControl.value?.subtotal | customNumberFormat: fractionDigits | currencySymbol }}
                                </td>
                                <td *ngIf="!viewOnly">
                                    <div class="p-d-flex">
                                        <span class="btnBars p-mr-0"
                                            (click)="removeProduct(index,productControl.value.productId)">
                                            <i class="pi pi-trash"></i>
                                        </span>
                                        <span *ngIf="productControl.value.typeId == typeIds.BundleTypeId || productControl.value.typeId == typeIds.KitTypeId" class="btnBars p-mr-0" (click)="openProductsDialogForBundle(productControl,index)">
                                            <i class="pi pi-plus"></i>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>

                        <!-- bundle items -->
                        <ng-template pTemplate="rowexpansion" let-parentControl>
                            <tr *ngFor="let productControl of getBundleProducts(parentControl).controls; let index=index" class="bundleRow">
                                <td></td>
                                <td *ngIf="checkedFields.item?.isChecked">
                                    {{ productControl.value?.itemNo }}
                                </td>
                                <td *ngIf="checkedFields.description?.isChecked">
                                    {{ productControl.value.description.length > 55 ? (productControl.value.description | slice: 0:55) + "..." :
                                    productControl.value.description }}
                                </td>
                                <td *ngIf="checkedFields.qty?.isChecked" pEditableColumn [formGroup]="productControl">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <p-inputNumber formControlName="productQty" [min]="1"
                                                (keypress)="isNumberKey($event)"
                                                [disabled]="viewOnly || (parentControl.value.typeId == typeIds.KitTypeId)" [disabled]="viewOnly"></p-inputNumber>
                                        </ng-template>
                                        <ng-template pTemplate="output"> {{ productControl.value.productQty }} </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="checkedFields.uom?.isChecked" pEditableColumn class="action" [formGroup]="productControl">
                                    <p-dropdown
                                        [options]="productControl.value.productUOM"
                                        formControlName="productUOMId"
                                        optionLabel="uomName"
                                        optionValue="unitOfMeasureId" appendTo="body"
                                        class="noBorderDD" [dropdownIcon]="dropdownIcon" [disabled]="true">
                                    </p-dropdown>
                                </td>
                                <td *ngIf="checkedFields.rate?.isChecked" pEditableColumn class="action" [formGroup]="productControl">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input" *ngIf="parentControl.value.typeId != typeIds.KitTypeId">
                                            <p-inputNumber formControlName="productPrice" mode="decimal" [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2" (keypress)="isNumberKey($event)" [disabled]="viewOnly"></p-inputNumber>
                                        </ng-template>
                                        <ng-template pTemplate="output" *ngIf="parentControl.value.typeId != typeIds.KitTypeId"> {{ productControl.value.productPrice | customNumberFormat: fractionDigits | currencySymbol}} </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="checkedFields.totalamount?.isChecked">
                                    <ng-container *ngIf="parentControl.value.typeId != typeIds.KitTypeId">
                                         {{ productControl.value?.amount | customNumberFormat: fractionDigits | currencySymbol }}
                                    </ng-container>
                                 </td>
                                <td class="action" *ngIf="discountEnabled && checkedFields.tbldiscount?.isChecked" [formGroup]="productControl">
                                    <div class="p-d-flex" *ngIf="parentControl.value.typeId != typeIds.KitTypeId">
                                        <p-dropdown
                                            formControlName="discountId"
                                            class="small"
                                            [options]="discountOptions"
                                            optionLabel="additionalDescription"
                                            optionValue="id"
                                            appendTo="body"
                                            [dropdownIcon]="dropdownIcon"
                                            [disabled]="viewOnly"
                                            (onChange)="changeRowDiscount($event,productControl)"
                                            [showClear]="true" placeholder="Select">
                                        </p-dropdown>
                                        <p-inputNumber formControlName="discountAmount" class="noBorder fix-width" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [min]="0" [disabled]="viewOnly || !parentControl.value.discountId"></p-inputNumber>
                                    </div>
                                </td>
                                <td *ngIf="checkedFields.tbltax?.isChecked">
                                    {{ (0.0) | customNumberFormat: fractionDigits | currencySymbol }}
                                </td>
                                <td class="action" *ngIf="checkedFields.table_handlingfee?.isChecked" [formGroup]="productControl">
                                    <div class="p-d-flex" *ngIf="parentControl.value.typeId != typeIds.KitTypeId">
                                        <p-dropdown
                                            formControlName="handlingChargeId"
                                            class="small"
                                            [options]="additionalFees"
                                            optionLabel="additionalname"
                                            optionValue="id"
                                            appendTo="body"
                                            [dropdownIcon]="dropdownIcon"
                                            (onChange)="changeRowHandlingFee($event,productControl)"
                                            [disabled]="viewOnly"
                                            [showClear]="true" placeholder="Select">
                                        </p-dropdown>
                                        <p-inputNumber formControlName="handlingChargeAmount" class="noBorder fix-width" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [min]="0" [disabled]="viewOnly || !parentControl.value.handlingChargeId"></p-inputNumber>
                                    </div>
                                </td>
                                <td *ngIf="checkedFields.amount?.isChecked">
                                   <ng-container *ngIf="parentControl.value.typeId != typeIds.KitTypeId">
                                        {{ productControl.value?.subtotal | customNumberFormat: fractionDigits | currencySymbol }}
                                   </ng-container>
                                </td>
                                <td *ngIf="!viewOnly">
                                    <span *ngIf="parentControl.value.bundleDetails?.length>1" class="btnBars p-mr-0"
                                        (click)="removeBundleProduct(parentControl,index,productControl.value.productId)">
                                        <i class="pi pi-trash"></i>
                                    </span>
                                </td>
                            </tr>
                        </ng-template>


                        <ng-template pTemplate="footer" let-product>
                            <tr>
                                <td rowspan="8" [attr.colspan]="3">
                                    <div [formGroup]="salesOrderForm" *ngIf="combinedCustomFields?.footer_item?.length>0">
                                        <div formArrayName="customAttributes">
                                            <div class="p-grid">
                                                <ng-container *ngFor="let customField of getAddedCustomAttributes(salesOrderForm); let itemIndex=index">
                                                    <ng-container *ngIf="customField.value.sectionCode=='footer_item'">
                                                        <div class="p-col-12" [formGroupName]="itemIndex">
                                                            <ng-container *ngTemplateOutlet="customAttributeFields; context: { customField: customField, itemIndex: itemIndex }"></ng-container>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="p-text-right" [attr.colspan]="tableFieldsCount>(3+lineAmountFieldCount)? tableFieldsCount-(3+lineAmountFieldCount) : 1"><strong>{{ checkedFields?.subtotal?.labelName}}</strong></td>
                                <td *ngIf="checkedFields.totalamount?.isChecked" style="width: 150px;">
                                    <strong>{{ salesOrderForm.getRawValue().lineAmount | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="discountEnabled && checkedFields.tbldiscount?.isChecked">
                                    <strong>{{ salesOrderForm.getRawValue().lineTotalDiscount | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="footerTaxEnabled && checkedFields.tbltax?.isChecked" style="width: 80px;">
                                    <strong>{{ (0) | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="checkedFields.table_handlingfee?.isChecked">
                                    <strong>{{ salesOrderForm.getRawValue().lineTotalHandlingFee | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="checkedFields.amount?.isChecked" style="width: 150px;">
                                    <strong>{{ salesOrderForm.getRawValue().subtotal | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="!viewOnly"></td>
                            </tr>
                            <tr *ngIf="checkedFields.discount?.isChecked && !checkedFields.tbldiscount?.isChecked">
                                <td class="p-text-right" [attr.colspan]="tableFieldsCount>3? tableFieldsCount-3 : 1">
                                    <div class="p-d-flex p-jc-end p-ai-center">
                                        <strong>{{ checkedFields.discount.labelName}}</strong>
                                        <div class="p-ml-2 p-d-flex" [formGroup]="salesOrderForm">
                                            <p-dropdown
                                                formControlName="discountId"
                                                class="small"
                                                [options]="discountOptions"
                                                optionLabel="additionalDescription"
                                                optionValue="id"
                                                appendTo="body"
                                                [dropdownIcon]="dropdownIcon"
                                                [disabled]="viewOnly"
                                                [showClear]="true" placeholder="Select">
                                            </p-dropdown>
                                            <p-inputNumber formControlName="discountAmount" class="noBorder fix-width" [min]="0" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" (keypress)="isNumberKey($event)" [disabled]="viewOnly"></p-inputNumber>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <strong>{{ salesOrderForm.getRawValue().calculatedDiscount | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="!viewOnly"></td>
                            </tr>
                            <tr *ngIf="footerTaxEnabled && checkedFields.tax?.isChecked">
                                <td class="p-text-right"[attr.colspan]="tableFieldsCount>3? tableFieldsCount-3 : 1">
                                    <div class="p-d-flex p-ai-center p-jc-end">
                                        <i class="pi pi-info-circle p-mr-1" aria-hidden="true" pTooltip="{{taxInfoTooptip}}" tooltipPosition="bottom"></i> <strong>{{ checkedFields.tax.labelName}}</strong>
                                    </div>
                                </td>
                                <td>
                                    <strong>{{ (0.0) | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="!viewOnly"></td>
                            </tr>
                            <tr *ngIf="checkedFields.handlingfee?.isChecked">
                                <td class="p-text-right" [attr.colspan]="tableFieldsCount>3? tableFieldsCount-3 : 1">
                                    <div class="p-d-flex p-jc-end p-ai-center">
                                        <strong>{{ checkedFields.handlingfee.labelName}}</strong>
                                        <div class="p-ml-2 p-d-flex" [formGroup]="salesOrderForm">
                                            <p-dropdown
                                                formControlName="handlingChargeId"
                                                class="small"
                                                [options]="additionalFees"
                                                optionLabel="name"
                                                optionValue="id"
                                                appendTo="body"
                                                [dropdownIcon]="dropdownIcon"
                                                [disabled]="viewOnly"
                                                [showClear]="true" placeholder="Select">
                                            </p-dropdown>
                                            <p-inputNumber formControlName="handlingChargeAmount" class="noBorder fix-width" [min]="0" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" (keypress)="isNumberKey($event)" [disabled]="viewOnly"></p-inputNumber>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <strong>{{ salesOrderForm.getRawValue().calculatedHandlingAmount | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="!viewOnly"></td>
                            </tr>
                            <tr *ngIf="discountEnabled && checkedFields.adddiscount?.isChecked">
                                <td class="p-text-right" [attr.colspan]="tableFieldsCount>3? tableFieldsCount-3 : 1">
                                    <div class="p-d-flex p-jc-end p-ai-center">
                                        <strong>{{ checkedFields.adddiscount.labelName}}</strong>
                                        <div class="p-ml-2 p-d-flex" [formGroup]="salesOrderForm">
                                            <p-dropdown
                                                formControlName="addlDiscountId"
                                                class="small"
                                                [options]="additionalDiscounts"
                                                optionLabel="additionalDescription"
                                                optionValue="id"
                                                appendTo="body"
                                                [dropdownIcon]="dropdownIcon"
                                                [disabled]="viewOnly"
                                                [showClear]="true" placeholder="Select">
                                            </p-dropdown>
                                            <p-inputNumber formControlName="addlDiscountAmount" class="noBorder fix-width" [min]="0" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" (keypress)="isNumberKey($event)" [disabled]="viewOnly"></p-inputNumber>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <strong>{{ salesOrderForm.getRawValue().calculatedAddlDiscount | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="!viewOnly"></td>
                            </tr>
                            <tr *ngIf="checkedFields.shipping?.isChecked">
                                <td class="p-text-right" [attr.colspan]="tableFieldsCount>3? tableFieldsCount-3 : 1"><strong>{{ checkedFields.shipping.labelName}}</strong></td>
                                <td [formGroup]="salesOrderForm">
                                    <p-inputNumber formControlName="shippingAmount" mode="decimal" [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2" (keypress)="isNumberKey($event)" class="footer-input" [disabled]="viewOnly"></p-inputNumber>
                                </td>
                                <td *ngIf="!viewOnly"></td>
                            </tr>
                            <tr *ngIf="checkedFields.ordertotal?.isChecked">
                                <td class="p-text-right" [attr.colspan]="tableFieldsCount>3? tableFieldsCount-3 : 1"><strong>{{ checkedFields.ordertotal.labelName}}</strong></td>
                                <td>
                                    <strong>{{ salesOrderForm.getRawValue().orderTotal | customNumberFormat: fractionDigits | currencySymbol }}</strong>
                                </td>
                                <td *ngIf="!viewOnly"></td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid" formArrayName="customAttributes">
                <div class="p-col-12 p-md-3" *ngIf="combinedCustomFields?.billing_address_item?.length>0">
                    <div class="p-fluid">
                        <div class="card" style="min-height: 160px">
                            <h6> Billing </h6>

                            <div class="p-grid">
                                <ng-container *ngFor="let customField of getAddedCustomAttributes(salesOrderForm); let itemIndex=index">
                                    <ng-container *ngIf="customField.value.sectionCode=='billing_address_item'">
                                        <div class="p-col-12" [formGroupName]="itemIndex">
                                            <ng-container *ngTemplateOutlet="customAttributeFields; context: { customField: customField, itemIndex: itemIndex }"></ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-3" *ngIf="combinedCustomFields?.shipping_address_item?.length>0">
                    <div class="p-fluid">
                        <div class="card" style="min-height: 160px">
                            <h6> Shipping </h6>

                            <div class="p-grid">
                                <ng-container *ngFor="let customField of getAddedCustomAttributes(salesOrderForm); let itemIndex=index">
                                    <ng-container *ngIf="customField.value.sectionCode=='shipping_address_item'">
                                        <div class="p-col-12" [formGroupName]="itemIndex">
                                            <ng-container *ngTemplateOutlet="customAttributeFields; context: { customField: customField, itemIndex: itemIndex }"></ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-3" *ngIf="combinedCustomFields?.section_item?.length>0">
                    <div class="p-fluid">
                        <div class="card" style="min-height: 160px">
                            <h6> {{combinedCustomFields?.section_item[0]?.section?.name}} </h6>

                            <div class="p-grid">
                                <ng-container *ngFor="let customField of getAddedCustomAttributes(salesOrderForm); let itemIndex=index">
                                    <ng-container *ngIf="customField.value.sectionCode=='section_item'">
                                        <div class="p-col-12" [formGroupName]="itemIndex">
                                            <ng-container *ngTemplateOutlet="customAttributeFields; context: { customField: customField, itemIndex: itemIndex }"></ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-3" *ngIf="combinedCustomFields?.misc_item?.length>0">
                    <div class="p-fluid">
                        <div class="card" style="min-height: 160px">
                            <h6> {{combinedCustomFields?.misc_item[0]?.section?.name}} </h6>

                            <div class="p-grid">
                                <ng-container *ngFor="let customField of getAddedCustomAttributes(salesOrderForm); let itemIndex=index">
                                    <ng-container *ngIf="customField.value.sectionCode=='misc_item'">
                                        <div class="p-col-12" [formGroupName]="itemIndex">
                                            <ng-container *ngTemplateOutlet="customAttributeFields; context: { customField: customField, itemIndex: itemIndex }"></ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-3" *ngIf="combinedCustomFields?.message_item?.length>0">
                    <div class="p-fluid">
                        <div class="card" style="min-height: 160px">
                            <h6> {{combinedCustomFields?.message_item[0]?.section?.name}} </h6>

                            <div class="p-grid">
                                <ng-container *ngFor="let customField of getAddedCustomAttributes(salesOrderForm); let itemIndex=index">
                                    <ng-container *ngIf="customField.value.sectionCode=='message_item'">
                                        <div class="p-col-12" [formGroupName]="itemIndex">
                                            <ng-container *ngTemplateOutlet="customAttributeFields; context: { customField: customField, itemIndex: itemIndex }"></ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </form>


    <p-footer>
        <button type="button" pButton (click)="closeCreateRecord()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!viewOnly" type="submit" pButton (click)="saveCreateRecord()" label="Save"></button>
    </p-footer>
</p-dialog>


<!-- Custom Attributes Fields -->
<ng-template #customAttributeFields let-customField="customField" let-itemIndex="itemIndex">
    <div>
        <label>{{ customField.value.labelName }} <span *ngIf="customField.value.isRequired" class="required-field">*</span></label>

        <ng-container [ngSwitch]="customField.value.formControlId">
            <!-- Input -->
            <ng-container *ngSwitchCase="formControlListIds.InputBox">
                <input *ngIf="!viewOnly" pInputText type="text" [formControl]="customField.controls.customAttributeValue" [placeholder]="'Enter value'"/>
                <input *ngIf="viewOnly" pInputText type="text" [placeholder]="'Enter value'" [(ngModel)]="customField.value.customAttributeValue"
                [ngModelOptions]="{standalone: true}" [disabled]="true"/>
            </ng-container>

            <!-- Number -->
            <ng-container *ngSwitchCase="formControlListIds.Number">
                <input *ngIf="!viewOnly" pInputText type="text" (keypress)="isNumberKey($event)" [formControl]="customField.controls.customAttributeValue" [placeholder]="'Enter value'"/>
                <input *ngIf="viewOnly" pInputText type="text" [placeholder]="'Enter value'" [(ngModel)]="customField.value.customAttributeValue"
                [ngModelOptions]="{standalone: true}" [disabled]="true"/>
            </ng-container>

            <!-- Decimal -->
            <ng-container *ngSwitchCase="formControlListIds.Decimal">
                <p-inputNumber ngIf="!viewOnly" [formControl]="customField.controls.customAttributeValue"
                                [minFractionDigits]="0"
                                [maxFractionDigits]="6" (keypress)="isNumberKey($event)">
                </p-inputNumber>
                <input *ngIf="viewOnly" pInputText type="text" [placeholder]="'Enter value'" [(ngModel)]="customField.value.customAttributeValue"
                [ngModelOptions]="{standalone: true}" [disabled]="true"/>
            </ng-container>

            <!-- Dropdown -->
            <ng-container *ngSwitchCase="formControlListIds.DropDownList">
                <p-dropdown
                    [options]="customField.value.pickListValues"
                    [placeholder]="'Select ' + customField.value.labelName"
                    [formControl]="customField.controls.customAttributeValue"
                    optionLabel="name" optionValue="name" appendTo="body"
                    [disabled]="viewOnly">
                </p-dropdown>
            </ng-container>

            <!-- Multiple Dropdown -->
            <ng-container *ngSwitchCase="formControlListIds.MultipleDropDownList">
                <p-multiSelect
                    [options]="customField.value.pickListValues"
                    [placeholder]="'Select ' + customField.value.labelName"
                    [formControl]="customField.controls.customAttributeValue"
                    optionLabel="name" optionValue="name" appendTo="body"
                    [disabled]="viewOnly">
                </p-multiSelect>
            </ng-container>

            <!-- CheckBox -->
            <ng-container *ngSwitchCase="formControlListIds.CheckBox">
                <ng-container *ngFor="let list of customField.value.pickListValues">
                    <p-checkbox [value]="list.name" [formControl]="customField.controls.customAttributeValue" [disabled]="viewOnly"></p-checkbox>
                    {{ list.name }}
                </ng-container>
            </ng-container>

            <!-- File Upload -->
            <ng-container *ngSwitchCase="formControlListIds.FileUpload">
                <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                    [showUploadButton]="false" [multiple]="true" [showCancelButton]="false" (onSelect)="onCustomUpload($event, customField, 'any')" [disabled]="viewOnly">
                    <ng-template pTemplate="file"></ng-template>
                    <ng-template pTemplate="content">
                        <ng-container *ngFor="let file of (customField.value.customAttributeValue||[]); let i = index;">
                                <div class="p-fileupload-row" *ngIf="file">
                                    <button pButton icon="fa fa-download" (click)="downloadFile(file.name, file.content)"
                                        class="p-button-link p-px-0 p-py-0">
                                    </button>
                                    <ng-container *ngIf="file.name.length > 15 else splitFileName">
                                        <div [pTooltip]="file.name">
                                            {{ file.name.substring(0, 14) }} ...
                                        </div>
                                    </ng-container>
                                    <ng-template #splitFileName>
                                        <div> {{ file.name }} </div>
                                    </ng-template>
                                    <div>
                                        {{ file.sizeInBytes | fileSize }}
                                    </div>
                                    <div *ngIf="!viewOnly">
                                        <button icon="pi pi-times" pButton (click)="removeCustomFile(i, customField)" type="button"
                                            icon="pi pi-times">
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                    </ng-template>
                </p-fileUpload>
            </ng-container>

            <!-- Picture -->
            <ng-container *ngSwitchCase="formControlListIds.Picture">
                <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                    accept="image/*" [multiple]="true" [showUploadButton]="false" [showCancelButton]="false"
                    (onSelect)="onCustomUpload($event, customField, 'image')" [disabled]="viewOnly">
                    <ng-template pTemplate="file"></ng-template>
                    <ng-template pTemplate="content">
                        <ng-container *ngFor="let picture of (customField.value.customAttributeValue||[]); let i = index;">
                            <div class="p-fileupload-row p-mb-2">
                                <button pButton icon="fa fa-download" (click)="downloadFile(picture.name, picture.content)"
                                    class="p-button-link p-px-0 p-py-0">
                                </button>
                                <ng-container *ngIf="picture.content && picture.content.startsWith('data') else localImage">
                                    <img src="{{ picture.content }}" width="100" alt="card" />
                                </ng-container>
                                <ng-template #localImage>
                                    <img [src]="picture.location" width="100" alt="card" />
                                </ng-template>
                                <ng-container *ngIf="picture.name.length > 15 else splitImageName">
                                    <div [pTooltip]="picture.name">
                                        {{ picture.name.substring(0, 14) }}...
                                    </div>
                                </ng-container>
                                <ng-template #splitImageName>
                                    <div> {{ picture.name }} </div>
                                </ng-template>
                                <div>
                                    {{ picture.sizeInBytes | fileSize }}
                                </div>
                                <div *ngIf="!viewOnly">
                                    <button icon="pi pi-times" pButton (click)="removeCustomFile(i, customField)" type="button"
                                        icon="pi pi-times">
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </ng-template>
                </p-fileUpload>
            </ng-container>

            <!-- Radio Button -->
            <ng-container *ngSwitchCase="formControlListIds.RadioButton">
                <ng-container *ngFor="let list of customField.value.pickListValues">
                    <p-radioButton [value]="list.name" [formControl]="customField.controls.customAttributeValue" [disabled]="viewOnly">
                    </p-radioButton>&nbsp; {{ list.name }}
                </ng-container>
            </ng-container>

            <!-- Date Picker -->
            <ng-container *ngSwitchCase="formControlListIds.DatePicker">
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" appendTo="body" [disabled]="viewOnly"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="false" [formControl]="customField.controls.customAttributeValue">
                </p-calendar>
            </ng-container>

            <!-- Rating -->
            <ng-container *ngSwitchCase="formControlListIds.Rating">
                <p-rating [cancel]="false" [formControl]="customField.controls.customAttributeValue" [disabled]="viewOnly"></p-rating>
            </ng-container>

            <!-- Toggle Button -->
            <ng-container *ngSwitchCase="formControlListIds.ToggleButton">
                <p-inputSwitch [formControl]="customField.controls.customAttributeValue" [disabled]="viewOnly"></p-inputSwitch>
            </ng-container>
        </ng-container>

        <div *ngIf="isRequiredTouched(customField)" class="p-invalid">
            <small>{{ customField.value.labelName }} is required</small>
        </div>
    </div>
</ng-template>
 <!-- Custom Attributes Fields End -->

<!--Product add common component -->
<app-product-selection-modal *ngIf="salesOrderForm" [displayProductSelectionModal]="displayProductSelectionModal" [moduleName]="moduleName"
    [headerText]="headerText" [selectedProductsList]="selectedProductsList" [isVisibleLocation]="isVisibleLocation"
    [selectedLocationId]="salesOrderForm.getRawValue().selectedLocation?.id" [selectedAccountId]="0" [pricebookConfig]="pricebookConfig"
    (onCancelClicked)="onProductCancelClicked($event)" (onProductAddComplete)="onProductAddComplete($event)">
</app-product-selection-modal>
